import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./HomeCRUD";
import { homeSlice } from "./HomeSlice";

const { actions } = homeSlice;

export const callMemberBalance = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .callHomeUI(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberBalanceFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberBalanceFetched");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
